import AnalyticsManager from '@vfgroup-oneplatform/foundation/AnalyticsManager';

import { PaymentTypes } from '../../../Payment/Utils/PaymentTypes';

const projectConfig = require('../../../project.config.json');

class PaymentTrackingManager {
  _getDataByType = type => {
    switch (type) {
      case PaymentTypes.GIFT_AFTER_PAY:
        return {
          journey_type: 'Top-up',
          page_section: 'Dashboard:Top-up:QA',
          page_name: 'Top-up my phone',
        };
      case PaymentTypes.BILLING_PAYMENT:
        return {
          journey_type: 'Payment',
          page_name: 'Payment',
          page_section: 'Payment:Payment QA',
        };
      default:
        break;
    }
  };

  trackEvent(event, type, additionalData = {}) {
    AnalyticsManager.trackEvent(event, {
      ...this._getDataByType(type),
      ...additionalData,
    });
  }

  trackView(event, type, additionalData = {}) {
    const nonOverridableData = {
      component_name: AnalyticsManager.getComponentName(projectConfig.name),
      component_version: AnalyticsManager.getComponentVersion(projectConfig.version),
      component_owner: AnalyticsManager.getComponentOwner(),
    };
    AnalyticsManager.trackView(event, {
      ...this._getDataByType(type),
      ...additionalData,
      ...nonOverridableData,
    });
  }
}

export default PaymentTrackingManager;
